import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AdminDeals } from "../components/admin/AdminDeals";
import { AdminAuctions } from "../components/admin/AdminAuctions";
import { AdminOrders } from "../components/admin/AdminOrders";
import { AdminMembers } from "../components/admin/AdminMembers";
import { AdminSubmissions } from "../components/admin/AdminSubmissions";
import { AdminAnalytics } from "../components/admin/AdminAnalytics";

const TABS = [
  ["analytics", "ANALYTICS"],
  ["deals", "DEALS & STOCK"],
  ["auctions", "AUCTIONS"],
  ["orders", "ORDERS"],
  ["members", "MEMBERS"],
  ["submissions", "SUPPLIER QUEUE"],
];

export default function AdminPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("analytics");

  useEffect(() => {
    if (user === false) navigate("/login", { state: { from: "/admin" } });
  }, [user, navigate]);

  if (!user) return null;
  if (user.role !== "admin")
    return (
      <div className="max-w-7xl mx-auto px-8 py-32 text-center font-display text-4xl text-[#FF3B30]" data-testid="admin-access-denied">
        ADMIN ACCESS ONLY.
      </div>
    );

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
      <div className="text-[10px] uppercase tracking-widest text-[#FF3B30] mb-2">Back Office</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-10">ADMIN<span className="text-[#FFCC00]">.</span></h1>
      <div className="flex flex-wrap gap-2 mb-10">
        {TABS.map(([key, label]) => (
          <button
            key={key}
            data-testid={`admin-tab-${key}`}
            onClick={() => setTab(key)}
            className={`px-5 py-2.5 font-display text-lg border transition-colors duration-150 ${tab === key ? "bg-[#FFCC00] text-black border-[#FFCC00]" : "border-[#27272A] text-white/60 hover:border-white/40"}`}
          >
            {label}
          </button>
        ))}
      </div>
      {tab === "analytics" && <AdminAnalytics />}
      {tab === "deals" && <AdminDeals />}
      {tab === "auctions" && <AdminAuctions />}
      {tab === "orders" && <AdminOrders />}
      {tab === "members" && <AdminMembers />}
      {tab === "submissions" && <AdminSubmissions />}
    </div>
  );
}
